import React from "react";
import styled from "styled-components";
import Container from "src/react/layout/container";
import { LinkButton } from "src/react/components/link";

const imageOptions = "?fm=jpg&fl=progressive";
const reasons = [
  {
    image:
      "//images.ctfassets.net/itvcls9imtx8/3MwNh3V0Ni7SbTuepmlAmM/ebbcd94c2a17ed89d5a3ac5d9160e5db/how-it-works-shaving-products.jpg",
    imageAlt: "Shaving products",
    description: `Choose your products.`,
  },
  {
    image:
      "//images.ctfassets.net/itvcls9imtx8/1670AiBWapHiF9v2C871xl/0c48ba7fe51c2250fc4620bf761345ae/Delivery-Image.png",
    imageAlt: "Cornerstone delivery box",
    description: `Choose how often you want your deliveries.`,
  },
  {
    image:
      "//images.ctfassets.net/itvcls9imtx8/6eEGeX3c19ywzWzei78wXt/9df35a29ed3320b9d43d5f39be210e44/iphone-hiw.jpg",
    imageAlt: "Phone with Cornerstone website",
    description: `Done! Change, delay or cancel at any time for free.`,
  },
];

function HowItWorks() {
  return (
    <Wrapper>
      <h1>
        <SectionTitlePart1>How it works</SectionTitlePart1>
        <SectionTitlePart2>In 3 simple steps</SectionTitlePart2>
      </h1>
      <HowItWorksSteps />
      <LinkButton
        align="center"
        tracking="custom"
        variant="primary"
        to="/shaving-bundles"
      >
        Get started
      </LinkButton>
    </Wrapper>
  );
}

export default HowItWorks;

function HowItWorksSteps() {
  return (
    <Reasons>
      {reasons.map((reason, index) => (
        <Reason key={index} column>
          <Image
            width="250"
            height="250"
            src={`${reason.image}${imageOptions}&w=250`}
            srcSet={`${reason.image}${imageOptions}&w=500 2x`}
            alt={reason.imageAlt}
          />
          <p>
            {index + 1}. {reason.description}
          </p>
        </Reason>
      ))}
    </Reasons>
  );
}

const Wrapper = styled(Container)`
  padding-top: 30px;
  padding-bottom: 40px;
  text-align: center;
`;

const SectionTitlePart1 = styled.div`
  font-size: 36px;
  line-height: 1.5;
  font-weight: 600;
`;

const SectionTitlePart2 = styled.div`
  margin-bottom: 10px;
`;

const Reasons = styled.div`
  margin-bottom: 20px;
  @media (min-width: 700px) {
    display: flex;
  }
`;

const Reason = styled.div`
  margin: 10px auto;
  max-width: 400px;
  @media (min-width: 700px) {
    flex-basis: 100%;
    :not(:first-child) {
      margin-left: 10px;
    }
    :not(:last-child) {
      margin-right: 10px;
    }
  }
`;

const Image = styled.img`
  display: block;
  margin: auto;
  width: 100%;
  max-width: 250px;
  height: auto;
`;
